import { render, staticRenderFns } from "./bf-input-number.vue?vue&type=template&id=1ad8a948&scoped=true&"
import script from "./bf-input-number.vue?vue&type=script&lang=js&"
export * from "./bf-input-number.vue?vue&type=script&lang=js&"
import style0 from "./bf-input-number.vue?vue&type=style&index=0&id=1ad8a948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad8a948",
  null
  
)

export default component.exports